






























import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Mutations } from '@/ts/store/Constants';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

@Component({
    components: {
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            swiperOptionTop: {
                loop: false,
                loopedSlides: 5,
                spaceBetween: 10,
            },
            swiperOptionThumbs: {
                loop: false,
                loopedSlides: 5,
                spaceBetween: 10,
                centeredSlides: true,
                slidesPerView: 'auto',
                touchRatio: 0.2,
                slideToClickedSlide: true,
            },
        };
    },
    computed: {
        ...mapGetters({
            userCurrentTicket: 'UserTickets/getUserCurrentTicket',
        }),
    },
})
export default class PreviewTicketAttachments extends Vue {
    public selectedImage: string = '';

    constructor() {
        super();
    }

    get ticketMedias() {
        return this.$store.getters['UserTickets/getActiveTicketImages'];
    }

    public setAttacheSrc(src: string)  {
        return 'data:image/png;charset=utf-8;base64,' + src;
    }

    public cancel() {
        this.$store.commit(Mutations.SET_PREVIEW_TICKET_ATTACHMENTS_VISIBILITY, false);
    }

    public openFullMode(image: string) {
        this.selectedImage = image;
    }

    public closeFullMode() {
        this.selectedImage = '';
    }
}
